export default __webpack_public_path__ + "static/media/logo.0c211466.png";